module.exports = __webpack_public_path__ + "img/onlyOnebg.b7f41524.png";